export default "__VITE_ASSET__8mrc8eI3__"